
  if (
    document.querySelector('input[name*="Condition"], #quick-add-options')
  ) {
  function applyUsedConditionLogic() {

    // ── 1. RADIO INPUT variant (main product page) ──────────────────────────
    const conditionInputs = document.querySelectorAll('input[name*="Condition"]');
    const bagInputs       = document.querySelectorAll('input[name*="In Original Bag"]');

    let activeConditionRadio = "";
    conditionInputs.forEach(input => {
      if (input.checked) activeConditionRadio = input.value;
    });

    if (conditionInputs.length > 0) {
      if (activeConditionRadio === "Used") {
        bagInputs.forEach(input => {
          input.disabled = true;
          const label = document.querySelector(`label[for="${input.id}"]`);
          if (label) {
            label.style.opacity      = "0.3";
            label.style.pointerEvents = "none";
            label.style.cursor       = "not-allowed";
          }
          if (input.value === "No") input.checked = true;
        });
      } else {
        bagInputs.forEach(input => {
          input.disabled = false;
          const label = document.querySelector(`label[for="${input.id}"]`);
          if (label) {
            label.style.opacity      = "1";
            label.style.pointerEvents = "auto";
            label.style.cursor       = "pointer";
          }
        });
      }
    }

    // ── 2. BUTTON SWATCH variant (quick-add overlay) ────────────────────────
    const quickAdd = document.querySelector('#quick-add-options');
    if (!quickAdd) return;

    // Find the active Condition swatch button
    const activeConditionBtn = quickAdd.querySelector(
      '.swatch-btn.active[data-option-index="0"]'
    );
    const isUsed = activeConditionBtn?.dataset.value === "Used";

    // All "In Original Bag" swatch buttons (option-index="1")
    const bagBtns = quickAdd.querySelectorAll('.swatch-btn[data-option-index="1"]');

    bagBtns.forEach(btn => {
      if (isUsed) {
        btn.disabled                = true;
        btn.style.opacity           = "0.3";
        btn.style.pointerEvents     = "none";
        btn.style.cursor            = "not-allowed";

        // Auto-activate "No" so the variant stays valid
        if (btn.dataset.value === "No") {
          btn.classList.add("active");
        } else {
          btn.classList.remove("active");
        }
      } else {
        btn.disabled            = false;
        btn.style.opacity       = "1";
        btn.style.pointerEvents = "auto";
        btn.style.cursor        = "pointer";
      }
    });
  }

  // ── Intercept Dawn's history.pushState (variant URL changes) ──────────────
  (function(history){
    const pushState = history.pushState;
    history.pushState = function(state) {
      if (typeof history.onpushstate === "function") {
        history.onpushstate({ state });
      }
      setTimeout(applyUsedConditionLogic, 50);
      return pushState.apply(history, arguments);
    };
  })(window.history);

  // ── Standard event hooks ───────────────────────────────────────────────────
  window.addEventListener('popstate', applyUsedConditionLogic);
  window.addEventListener('load',     applyUsedConditionLogic);

  // Catches both radio changes AND swatch button clicks in one listener
  document.addEventListener('change', applyUsedConditionLogic);
  document.addEventListener('click',  e => {
    if (e.target.matches('#quick-add-options .swatch-btn')) {
      // Small delay so the theme can toggle .active before we read it
      setTimeout(applyUsedConditionLogic, 20);
    }
  });

  // ── Short poll to catch slow renders ──────────────────────────────────────
  let pollCount = 0;
  const poll = setInterval(() => {
    applyUsedConditionLogic();
    if (pollCount++ > 10) clearInterval(poll);
  }, 200);
    }

